// extracted by mini-css-extract-plugin
export var footer = "_l7-5";
export var fulfillmentInput = "_l7-0";
export var shipDateInput = "_l7-1";
export var shipmentModal = "_l7-2";
export var shipmentModalContent = "_l7-3";
export var tableContainer = "_l7-4";